






import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import ActionShowButton from '@/modules/shared/components/shared/table/action/ActionShowButton.vue'
import { AdminVipGroupRoute } from '@/modules/vip-group/routes/admin-vip-group.route'
import { VipGroupCollectionModel } from '@/modules/vip-group/models/vip-group-collection.model'

@Component({
  components: {
    BaseButton,
    ActionShowButton
  }
})
export default class AdminVipGroupActions extends Vue {

  constructor(
    private readonly routes: AdminVipGroupRoute
  ) {
    super()
  }

  @Prop() vipGroup!: VipGroupCollectionModel

  get showPageURL() {
    return this.routes.show(this.vipGroup.id)
  }
}

